<template>
  <div class="payment-detail-page new-payment-design">
    <!-- <Header /> -->
    <div>
      <h2>Choose your preferred mode of payment</h2>
      <v-card
      >
        <v-list-item>
          <v-list-item-content>
            <p>Please select your convenient mode of payment</p>
          </v-list-item-content>
        </v-list-item> 
        <v-list-item>
          <v-list-item-content>
            <v-card @click="choose">
              <v-img
                max-height="120"
                max-width="120"
                :src="cashfree_pic"
                :lazy-src="cashfree_pic"
              ></v-img> 
              <span>Internet banking/UPI's/Wallets/Cards</span>
              <v-img
                max-height="20"
                max-width="20"
                src="../../assets/images/right-arrow.png"
                ></v-img>
            </v-card>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-card @click="choose">
              <v-img
                max-height="120"
                max-width="120"
                :src="razorpay_pic"
                :lazy-src="razorpay_pic"
              ></v-img>
              <span>UPI's/Netbanking/Cards</span>
              <v-img
                max-height="20"
                max-width="20"
                src="../../assets/images/right-arrow.png"
                ></v-img>
            </v-card>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <p>Receipt will be generated and will be sent to the registered email provided.</p>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </div>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify';
  import Header from '../common/Header.vue';
  import { CREATE_USER_PLAN_SUBSCRIPTION, VERIFY_RAZORPAY_SIGNATURE, UPDATE_PROFILE_DETAIL } from "../../store/actions.type";
  import JwtService from ".././common/jwt.service";
  export default {
    components: {Header},
    data: () => ({
      cashfree_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'cashfree.png',
      razorpay_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'razorpay.png',
      pricingListName:JwtService.getPricingListName(),
      monthly:JwtService.getMonthly(),
      amount:JwtService.getAmount(),
      currency:JwtService.getCurrency(),
      plan_id:JwtService.getPlan(),
      name:'',
      email:'',
      mobile_no:'',
      plan_type:'',
      subscription_id:'',
      customer_id:'',
    }),
    created() {
      Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        }).then((user) => {
          this.name  = user.attributes['custom:name'];
          this.email = user.attributes['email'];
          this.mobile_no = user.attributes['custom:phonenumber'];
        })
        .catch(err => {
          this.$router.push({ name: 'Login' }).catch(()=>{});
        });
      },
    methods: {
      proceed() {
        this.$loading(true)
        this.$store.dispatch(CREATE_USER_PLAN_SUBSCRIPTION, {
          data: {
            name:this.name,
            email:this.email,
            mobile_no:this.mobile_no,
            amount:this.amount * 100,
            currency:this.currency,
            aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
            plan_id:this.plan_id,
            plan_type:this.monthly,
          },
          api: "create-user-plan-subscription"
        })
        .then(() =>  {
          this.subscription_id = this.$store.getters.getUserPlanSubscription.data.subscription_id;
          var options = {
            "key": "rzp_test_AdFDgVWagtsr6M",
            "amount": this.amount * 100,
            "currency": "INR",
            "subscription_id": this.subscription_id,
            "name": this.name,
            "description": this.pricingListName + '('+this.monthly.charAt(0).toUpperCase() + this.monthly.slice(1)+' Plan)',
            "image": "",
            "handler": (response) =>  {
              this.$loading(true)
              this.$store.dispatch(VERIFY_RAZORPAY_SIGNATURE, {
                data: {
                  aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
                  razorpay_payment_id:response.razorpay_payment_id,
                  razorpay_subscription_id:response.razorpay_subscription_id,
                  razorpay_signature:response.razorpay_signature,
                  plan_id:this.plan_id,
                  name:this.name,
                  email:this.email,
                },
                api: "verify-razorpay-signature"
              })
              .then(() =>  {
                let updatedDetail = [
                  {key:'is_plan_active', value:this.$store.getters.getVerifyRazorpaySignature.data.is_plan_active},
                  {key:'subscription_plans', value:this.$store.getters.getVerifyRazorpaySignature.data.subscription_plans},
                  {key:'show_add_family_member_button', value:this.$store.getters.getVerifyRazorpaySignature.show_add_family_member_button}
                ]
                this.$store.dispatch(UPDATE_PROFILE_DETAIL,updatedDetail)
                this.$router.push({ name: 'SubscriptionCongratulations' }).catch(()=>{})
                this.$loading(false);
              })
              .catch((error) =>  {
                this.$loading(false)
              });

            },
            "prefill": {"name": this.name,"email": this.email,"contact": this.mobile_no},
            "notes": {"note_key_1": "Tea. Earl Grey. Hot","note_key_2": "Make it so."},
            "theme": {"color": "#3399cc"}
          };
          var rzp1 = new Razorpay(options);
          rzp1.on('payment.failed', function (response){
            this.$loading(false)
          });
          rzp1.open().then((response) => {
            this.$loading(false);
          });
        })
        .catch((error) => {
          this.$loading(false);
        });
      },
      choose(){
        console.log('called');
      }
    }
  }
</script>